import {
  CONFIRMED_CREATE_PRESCRIPTION_ACTION,
  CONFIRMED_GET_SUGGESTED_PRESCRIPTION_ACTION,
  CONFIRMED_GET_PATIENT_PRESCRIPTIONS_ACTION,
  UPDATE_DURATION_REQUEST,
  UPDATE_DURATION_SUCCESS,
  UPDATE_DURATION_FAILURE,
  STOP_PATIENT_PRESCRIPTION_REQUEST,
  STOP_PATIENT_PRESCRIPTION_SUCCESS,
  STOP_PATIENT_PRESCRIPTION_FAIL,
  UPDATE_PRESCRIPTION_REQUEST,
  UPDATE_PRESCRIPTION_SUCCESS,
  UPDATE_PRESCRIPTION_FAIL,
} from "./PrescriptionType";
import {
  createPrescription,
  getSuggestedPrescription,
  updateDuration,
  getPatientPrescriptions,
  holdPatientMedicines,
  stopPatientPrescription,
  updatePrescription
} from "../../services/PrescriptionService";

function getAuthToken(getState) {
  const stateToken = getState().auth?.authKey;
  if (stateToken) return stateToken;
  const storedUser = localStorage.getItem("userDetails");
  return storedUser ? JSON.parse(storedUser).token : null;
}

export function createPrescriptionAction(prescriptionData) {
  return async (dispatch, getState) => {
    try {
      const token = getAuthToken(getState);
      console.log("Prescription Data to send:", prescriptionData);
      const requestData = {
        patient_id: prescriptionData.patient_id,
        duration: prescriptionData.duration,

        // ✅ NEW REQUIRED FIELDS
        prescription_validity_days:
          prescriptionData.prescription_validity_days || "",

        note: prescriptionData.note || "",

        pathyas: prescriptionData.pathyas || "",
        pathya_id: prescriptionData.pathya_id || "",

        medicine_arr: prescriptionData.medicine_arr,

        chunked_months: prescriptionData.chunked_months || "",

        disease_ids: prescriptionData.disease_ids || "",

        discount_type: prescriptionData.discount_type || "none",
        discount_percentage: prescriptionData.discount_percentage || 0,
        discount_amount: prescriptionData.discount_amount || 0,

        panchakarma_recommended:
          prescriptionData.panchakarma_recommended || "NO",

        items_subtotal: prescriptionData.items_subtotal || "0.00",
        items_cgst_amount: prescriptionData.items_cgst_amount || "0.00",
        items_sgst_amount: prescriptionData.items_sgst_amount || "0.00",
        items_igst_amount: prescriptionData.items_igst_amount || "0.00",
        gst_price: prescriptionData.gst_price || "0.00",
        igst_price: prescriptionData.igst_price || "0.00",
      };

      console.log("Final request data:", requestData);
      const response = await createPrescription(requestData);
      console.log("API raw response:", response);
      if (response?.data) {
        dispatch({
          type: CONFIRMED_CREATE_PRESCRIPTION_ACTION,
          payload: response.data.data,
        });
        return true;
      }
      throw new Error("Unexpected response format");
    } catch (error) {
      console.error(
        "Prescription Submission Error:",
        error.response?.data || error.message
      );
      throw error;
    }
  };
}

export function updatePrescriptionAction(prescriptionData) {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: UPDATE_PRESCRIPTION_REQUEST });

      const token = getAuthToken(getState);

      console.log("UPDATE Prescription Data:", prescriptionData);

      const requestData = {
        prescription_id: prescriptionData.prescription_id, // 🔥 MUST

        patient_id: prescriptionData.patient_id,
        duration: prescriptionData.duration,

        prescription_validity_days:
          prescriptionData.prescription_validity_days || "",

        note: prescriptionData.note || "",

        pathyas: prescriptionData.pathyas || "",
        pathya_id: prescriptionData.pathya_id || "",

        medicine_arr: prescriptionData.medicine_arr,
        chunked_months: prescriptionData.chunked_months || "",

        disease_ids: prescriptionData.disease_ids || "",

        discount_type: prescriptionData.discount_type || "none",
        discount_percentage: prescriptionData.discount_percentage || 0,
        discount_amount: prescriptionData.discount_amount || 0,

        panchakarma_recommended:
          prescriptionData.panchakarma_recommended || "NO",

        items_subtotal: prescriptionData.items_subtotal || "0.00",
        items_cgst_amount: prescriptionData.items_cgst_amount || "0.00",
        items_sgst_amount: prescriptionData.items_sgst_amount || "0.00",
        items_igst_amount: prescriptionData.items_igst_amount || "0.00",
        gst_price: prescriptionData.gst_price || "0.00",
        igst_price: prescriptionData.igst_price || "0.00",
      };

      console.log("Final UPDATE request:", requestData);

      const response = await updatePrescription(requestData);

      if (response?.data?.status === "success") {
        dispatch({
          type: UPDATE_PRESCRIPTION_SUCCESS,
          payload: response.data.data,
        });

        return { success: true };
      }

      throw new Error(response?.data?.message || "Update failed");
    } catch (error) {
      dispatch({
        type: UPDATE_PRESCRIPTION_FAIL,
        payload: error.response?.data?.message || error.message,
      });

      console.error(
        "Update Prescription Error:",
        error.response?.data || error.message
      );

      return {
        success: false,
        error: error.response?.data?.message || error.message,
      };
    }
  };
}
export function getSuggestedPrescriptionAction(prescriptionData) {
  return async (dispatch, getState) => {
    try {
      const token = getAuthToken(getState);
      console.log("get suggested Prescription Data=====> :", prescriptionData);
      const formattedDiseaseIds = Array.isArray(prescriptionData.disease_ids)
        ? prescriptionData.disease_ids.join(",")
        : prescriptionData.disease_ids;
      const response = await getSuggestedPrescription({
        patient_id: prescriptionData.patient_id,
        disease_ids: formattedDiseaseIds,
      });
      console.log("API raw response for suggested prescriptions:", response);
      if (
        response?.data?.status === "success" &&
        Array.isArray(response.data.data)
      ) {
        const transformedData = {
          data: response.data.data.map((item) => ({
            medicine_id: item.medicine_id,
            medicine_name: item.medicine_name,

            // ✅ IMPORTANT FIX
            medicine_type_text: item.medicine_type_text || "Not specified",

            dose: item.dose || "",              // 🔥 ADD THIS
            dose_text: item.dose_text || "",         // optional

            frequency: item.frequency || "1", // 🔥 FIX (not default_frequency)
            frequency_text: item.frequency_text || "",

            // 🔥 ADD THIS (MAIN FIX)
            package_qty: item.package_qty || "1",

            anupana_text: item.anupana_text || "",
            default_instructions: item.default_instructions || "-",

            default_dose_id: item.dose,
            default_frequency_id: item.frequency,
            how_to_take_id: item.how_to_take_id,
            anupana_id: item.anupana_id,

            base_price: item.base_price || "1",
            CGST: item.CGST || "1",
            SGST: item.SGST || "1",
            IGST: item.IGST || "1",
            cgst_sgst_price: item.cgst_sgst_price || "1",
            igst_price: item.igst_price || "1",
          })),
        };
        dispatch({
          type: CONFIRMED_GET_SUGGESTED_PRESCRIPTION_ACTION,
          payload: transformedData,
        });
        return transformedData;
      }
      return { data: [] };
    } catch (error) {
      console.error(
        "Suggested Prescription Error:",
        error.response?.data || error.message
      );
      return { data: [] };
    }
  };
}

export function updateDurationAction(data) {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: UPDATE_DURATION_REQUEST });
      const token = getAuthToken(getState);
      const response = await updateDuration({
        patient_id: data.patient_id,
        prescription_id: data.prescription_id,
        duration: data.duration,
        updated_qty: data.updated_qty,
        items_subtotal: data.items_subtotal,
        items_cgst_amount: data.items_cgst_amount,
        items_sgst_amount: data.items_sgst_amount,
        items_igst_amount: data.items_igst_amount,
        gst_price: data.gst_price,
        igst_price: data.igst_price,
      });
      if (response?.data?.status === "success") {
        dispatch({
          type: UPDATE_DURATION_SUCCESS,
          payload: response.data.data,
        });
        return response.data;
      }
      throw new Error(response?.data?.message || "Failed to update duration");
    } catch (error) {
      dispatch({
        type: UPDATE_DURATION_FAILURE,
        payload: error.response?.data?.message || error.message,
      });
      throw error;
    }
  };
}

export function getPatientPrescriptionsAction(prescriptionData) {
  return async (dispatch, getState) => {
    try {
      const response = await getPatientPrescriptions({
        patient_id: prescriptionData.patient_id,
      });
      console.log("API raw response for patient prescriptions:", response);
      const apiData = response?.data;
      if (apiData?.status === "success" && Array.isArray(apiData.data)) {
        const mappedData = apiData.data.map((prescription) => {
          const medicinesWithDelivery = prescription.medicines.map(
            (medicine) => {
              // Set default delivery status and option if not provided
              const delivery_option = medicine.delivery_option || "PENDING";
              const delivery_status = medicine.delivery_status || "PENDING";
              // return {
              //   // FIX: Include medicine_id in the mapped object
              //   medicine_id: medicine.medicine_id,
              //   prescription_medicine_id: medicine.prescription_medicine_id,
              //   medicine_name: medicine.medicine_name,
              //   medicine_type: medicine.medicine_type,
              //   dose: medicine.dose,
              //   frequency: medicine.frequency,
              //   qty: medicine.qty,
              //   package_qty: medicine.package_qty,
              //   delivered_qty: medicine.delivered_qty || 0,
              //   updated_qty: medicine.updated_qty,
              //   delivery_status: delivery_status,
              //   delivery_option: delivery_option,
              //   how_to_take: medicine.how_to_take,
              //   anupan: medicine.anupan,
              //   is_hold: medicine.is_hold,
              //   hold_date: medicine.hold_date,
              //   // Include is_custom field for separating custom and regular medicines
              //   is_custom: medicine.is_custom,
              //   custom_duration_in_days: medicine.custom_duration_in_days,
              //   // Include additional fields that might be needed
              //   base_price: medicine.base_price,
              //   CGST: medicine.CGST,
              //   SGST: medicine.SGST,
              //   IGST: medicine.IGST,
              //   cgst_sgst_price: medicine.cgst_sgst_price,
              //   igst_price: medicine.igst_price,
              //   item_subtotal: medicine.item_subtotal,
              //   item_cgst_amount: medicine.item_cgst_amount,
              //   item_sgst_amount: medicine.item_sgst_amount,
              //   item_igst_amount: medicine.item_igst_amount,
              //   item_gst_price: medicine.item_gst_price,
              //   item_igst_price: medicine.item_igst_price,
              // };
              return {
                medicine_id: medicine.medicine_id,
                prescription_medicine_id: medicine.prescription_medicine_id,
                medicine_name: medicine.medicine_name,
                medicine_type: medicine.medicine_type,

                dose: medicine.dose,
                frequency: medicine.frequency,

                // qty: Number(medicine.qty || 0),
                qty: medicine.qty,
                quantity: Number(medicine.qty || 0),

                quantity: Number(medicine.qty || 0), // ✅ fixed
                package_qty: Number(medicine.package_qty || 1), // ✅ fixed

                how_to_take: medicine.how_to_take,
                how_to_take_id: medicine.how_to_take_id,

                anupan: medicine.anupan,
                anupan_id: medicine.anupan_id,

                default_dose_id: medicine.default_dose_id,
                default_frequency_id: medicine.default_frequency_id,

                is_external: medicine.is_external,

                is_custom: medicine.is_custom,
                custom_duration_in_days: medicine.custom_duration_in_days,

                base_price: Number(medicine.base_price || 0),
                CGST: Number(medicine.CGST || 0),
                SGST: Number(medicine.SGST || 0),
                IGST: Number(medicine.IGST || 0),

                cgst_sgst_price: Number(medicine.cgst_sgst_price || 0),
                igst_price: Number(medicine.igst_price || 0),

                item_subtotal: Number(medicine.item_subtotal || 0),
                item_cgst_amount: Number(medicine.item_cgst_amount || 0),
                item_sgst_amount: Number(medicine.item_sgst_amount || 0),
                item_igst_amount: Number(medicine.item_igst_amount || 0),

                item_gst_price: Number(medicine.item_gst_price || 0),
                item_igst_price: Number(medicine.item_igst_price || 0),

                delivered_qty: Number(medicine.delivered_qty || 0),
                updated_qty: Number(medicine.updated_qty || 0),

                delivery_status: medicine.delivery_status || "PENDING",
                delivery_option: medicine.delivery_option || "PENDING",
              };
            }
          );
          return {
            prescription_id: prescription.prescription_id,
            patient_id: prescription.patient_id,
            duration: prescription.duration,
            note: prescription.note || "No notes",
            status: prescription.status,
            is_stop: prescription.is_stop,
            stopped_date: prescription.stopped_date,
            mark_as_complete: prescription.mark_as_complete,
            items_subtotal: prescription.items_subtotal,
            prescription_payment_status:
              prescription.prescription_payment_status,
            prescribed_by: prescription.prescribed_by || "Unknown",
            created_by: prescription.created_by,
            created_at: prescription.created_at,

            // 🔥 ADD THESE (MAIN FIX)
            pathyas: prescription.pathyas,
            pathya_id: prescription.pathya_id,
            prescription_validity_days: prescription.prescription_validity_days,
            discount_type: prescription.discount_type,
            discount_amount: prescription.discount_amount,
            panchakarma_recommended: prescription.panchakarma_recommended,

            medicines: medicinesWithDelivery,

            receipt_download_link: prescription.receipt_download_link,
            diseases: prescription.diseases || [],

            totals: {
              items_subtotal: prescription.items_subtotal || 0,
              items_cgst_amount: prescription.items_cgst_amount || 0,
              items_sgst_amount: prescription.items_sgst_amount || 0,
              items_igst_amount: prescription.items_igst_amount || 0,
              gst_price: prescription.gst_price || 0,
              igst_price: prescription.igst_price || 0,
            },
          };
        });
        dispatch({
          type: CONFIRMED_GET_PATIENT_PRESCRIPTIONS_ACTION,
          payload: mappedData,
        });
        console.log("Final mapped prescriptions:", mappedData);
        return mappedData;
      }
      return [];
    } catch (error) {
      console.error(
        "Failed to fetch patient prescriptions:",
        error.response?.data || error.message
      );
      return [];
    }
  };
}

export const holdPatientMedicineAction = (prescription_id, hold_medicines) => {
  return async (dispatch) => {
    dispatch({ type: "HOLD_PATIENT_MEDICINE" });
    try {
      console.log("Sending hold request:", { prescription_id, hold_medicines });
      const response = await holdPatientMedicines({
        prescription_id,
        hold_medicines, // This should be medicine_ids separated by "|" (e.g., "6|3|1")
      });
      console.log("Hold medicine response:", response.data);
      dispatch({
        type: "HOLD_PATIENT_MEDICINE_SUCCESS",
        payload: response.data,
      });
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error("Hold medicine error:", error);
      dispatch({
        type: "HOLD_PATIENT_MEDICINE_FAIL",
        payload: error?.response?.data?.message || "Failed to hold medicines",
      });
      return {
        success: false,
        error: error?.response?.data?.message || "Failed to hold medicines",
      };
    }
  };
};

export const stopPatientPrescriptionAction = (prescription_id) => {
  return async (dispatch) => {
    dispatch({ type: STOP_PATIENT_PRESCRIPTION_REQUEST });

    try {
      const response = await stopPatientPrescription({
        prescription_id,
      });

      if (response?.data?.status === "success") {
        dispatch({
          type: STOP_PATIENT_PRESCRIPTION_SUCCESS,
          payload: prescription_id,
        });

        return { success: true };
      }

      return {
        success: false,
        error: response?.data?.message || "Failed to stop prescription",
      };
    } catch (error) {
      dispatch({
        type: STOP_PATIENT_PRESCRIPTION_FAIL,
        payload:
          error?.response?.data?.message || "Failed to stop prescription",
      });

      return {
        success: false,
        error:
          error?.response?.data?.message || "Failed to stop prescription",
      };
    }
  };
};